import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import ConfigurationActions from "../../../../reducers/modules/accounting/configuration/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "accounting/config";

export default class ConfigurationMiddleware {
  static create() {
    return (dispatch) => {
      dispatch(ConfigurationActions.create());
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(ConfigurationActions.update());
      ConfigurationMiddleware.showOne(dispatch, params);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(ConfigurationActions.process());
      ConfigurationMiddleware.showlist(dispatch, params);
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(ConfigurationActions.reset());
    };
  }
  static resetList() {
    return (dispatch) => {
      dispatch(ConfigurationActions.resetList());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(ConfigurationActions.view());
      ConfigurationMiddleware.showOne(dispatch, params);
    };
  }

  static getConfigHelper(params) {
    return (dispatch) => {
      dispatch(ConfigurationActions.view());
      ConfigurationMiddleware.showConfigHelper(dispatch, params);
    };
  }

  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(ConfigurationActions.submit());
      ConfigurationMiddleware.saveNew(dispatch, post, search);
    };
  }
  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(ConfigurationActions.submit());
      ConfigurationMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }
  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(ConfigurationActions.delete());
      ConfigurationMiddleware.delete(dispatch, params, id);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ConfigurationMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(ConfigurationActions.list(response.data.result));
        }
      })
      .catch((error) => {
        ConfigurationMiddleware.alertHendler(dispatch, error);
      });
  }
 
  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ConfigurationMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(ConfigurationActions.view(response.data.result));
        }
      })
      .catch((error) => {
        ConfigurationMiddleware.alertHendler(dispatch, error);
      });
  }

  static showConfigHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ConfigurationMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-config-helper",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(ConfigurationActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        ConfigurationMiddleware.alertHendler(dispatch, error);
      });
  }

  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ConfigurationMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            ConfigurationActions.process(),
            ConfigurationMiddleware.showlist(dispatch, params)
          );
          ConfigurationMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        ConfigurationMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ConfigurationMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            ConfigurationActions.process(),
            ConfigurationMiddleware.showlist(dispatch, search)
          );
          dispatch(ConfigurationActions.success());
          ConfigurationMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        ConfigurationMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${ConfigurationMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            ConfigurationActions.process(),
            ConfigurationMiddleware.showlist(dispatch, search)
          );
          dispatch(ConfigurationActions.success());
          ConfigurationMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        ConfigurationMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(ConfigurationActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(ConfigurationActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
